export const APP_NAME = '';

export const NAVBAR_ITEMS = [
  {
    value: 'Home',
    to: '/',
    icon: 'home',
    useExact: true,
  },
  {
    value: 'Lucky Draw',
    icon: 'box',
    to: '/',
  },
  {
    value: 'FAQ',
    icon: 'list',
    to: '/faq',
  },
  {
    value: 'LIST',
    icon: 'list',
    to: '/list',
  },
];

export const SPONSORS = [
  {
    name: 'Best Web Design Singapore',
    url: 'https://www.bestwebdesign.sg/',
    img: './images/best-web-design-singapore-logo.png',
  },
  {
    name: 'ECEmbroid',
    url: 'https://www.ecembroid.com',
    img: './images/ecembroid.png',
  },
  {
    name: 'The Roofing Specialist',
    url: 'https://theroofspecialist.com.sg/',
    img: './images/theroofingspecialist.png',
  },
  {
    name: 'J&K Roof Contractors',
    url: 'https://www.jkroof.com.sg/',
    img: './images/JKRoof.png',
  },
  {
    name: 'LS Home Renovation',
    url: 'https://www.lshomerenovation.sg/',
    img: './images/ls-home-renovation-best-home-renovation-contractor-singapore-logo.png',
  },
  {
    name: 'SinHao - Structural Stainless Steel Works',
    url: 'https://sinhaocontractor.sg/',
    img: './images/sinhao-best-structural-stainless-steel-contractor-singapore.png',
  },
];
